import { createAction, props } from '@ngrx/store';

export const validatePassword = createAction(
  '[Account] Validate Password',
  props<{ password: string }>()
);

export const validatePasswordSuccess = createAction(
  '[Account] Validate Password Success',
  props<{ message: string }>()
);

export const validatePasswordFailure = createAction(
  '[Account] Validate Password Failure',
  props<{ error: string }>() // You can adjust the payload type based on your needs
);

export const deleteAccount = createAction('[Account] Delete Account');

export const deleteAccountSuccess = createAction(
  '[Account] Delete Account Success',
  props<{ message: string }>()
);

export const deleteAccountFailure = createAction(
  '[Account] Delete Account Failure',
  props<{ error: string }>()
);
